/**
 * Flying swords and thrown needles (fx 'nine', 'needles'): a volley circling the caster, then flying to
 * each target.
 */
import { registerFx } from './registry';

registerFx(['needles', 'nine'], (host) => ({
  skill: ({ src, srcId, s, sx, sy, volley }) => {
    const list = volley ?? [];
    list.forEach((v, k) =>
      host.swords.push({
        srcId,
        tgtId: v.tgtId,
        t: 0,
        launch: v.at - 0.15,
        arrive: v.at,
        ang: (k / list.length) * Math.PI * 2,
        x: sx,
        y: sy - 22 * host.tall(src),
        fx: 0,
        fy: 0,
        rot: -Math.PI / 2,
        needle: s.fx === 'needles',
      }),
    );
    host.fx.push({ type: 'sigil', x: sx, y: sy, t: 0, life: 0.9, r: 26, col: '120,210,255' });
    host.sfx.nine();
  },
}));
